import { jsx as t, jsxs as Q } from "react/jsx-runtime";
import { memo as U, forwardRef as W, useState as T, useRef as X, useCallback as a, useEffect as h } from "react";
import Z from "./CalendarMonth.mjs";
import q from "./index163.mjs";
import oo from "./index164.mjs";
import A from "./index165.mjs";
import E from "./index166.mjs";
import to from "./index167.mjs";
import eo from "./index168.mjs";
import { LICENSE_KEY as io } from "./constants11.mjs";
import ro from "./ChevronRightRounded.mjs";
import so from "./ChevronLeftRounded.mjs";
import no from "./ArrowDropDownRounded.mjs";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useFormFieldSize as mo } from "./useFormFieldSize.mjs";
import { TextField as ao } from "./index53.mjs";
import { useLocale as co } from "./useLocale.mjs";
import { TEST_IDS as fo } from "./testIds.mjs";
import { Day as po } from "./Day.mjs";
import { DATE_FORMAT as lo } from "./constants12.mjs";
import { DatePickerGlobalStyle as uo, OverLabel as ho, StyledDatePicker as Do } from "./styles7.mjs";
import { InputLabelBase as ko } from "./index46.mjs";
import { AdapterDateFns as Fo } from "./AdapterDateFns.mjs";
import { LicenseInfo as yo } from "./licenseInfo.mjs";
import { LocalizationProvider as Lo } from "./LocalizationProvider.mjs";
yo.setLicenseKey(io);
const Po = {
  es: q,
  "zh-Hans": {
    ...E,
    options: {
      ...E.options,
      weekStartsOn: 1
    }
  },
  "zh-Hant": {
    ...A,
    options: {
      ...A.options,
      weekStartsOn: 1
    }
  },
  en: oo
}, So = "dd.MM.yyyy", wo = ({ name: e, ...i }) => /* @__PURE__ */ t(ao, { id: e, name: e, ...i }), Xo = U(
  W(
    ({
      name: e,
      label: i,
      fullWidth: _ = !0,
      size: c = "small",
      labelType: D = "inside",
      value: r,
      defaultValue: b = null,
      error: k,
      helperText: R,
      onBlur: Io,
      onChange: g,
      onAccept: d,
      isOptional: F,
      onClose: f,
      disabled: z,
      placeholder: B,
      open: p,
      format: v = lo,
      inputRef: s,
      required: l = !1,
      slotProps: x,
      slots: K,
      ...y
    }, M) => {
      const { locale: C } = co(), [u, n] = T(!1), [L, P] = T(null), S = X(null), O = s ?? S, V = mo(c), $ = y["data-testid"] || fo.dateInput, w = D === "outside" ? i : void 0, j = D === "inside" && i ? /* @__PURE__ */ t(ko, { required: l, isOptional: F, children: i }) : void 0, H = a(
        (o) => {
          d && o !== void 0 && d(o), n(!1);
        },
        [d]
      ), G = a(() => {
        f && f(), n(!1);
      }, [f]), m = a(() => {
        typeof s != "function" && s?.current ? s.current.focus() : S?.current?.focus();
      }, [s]), N = a(
        (o) => {
          if (o.key === "Enter") {
            o.preventDefault(), n((J) => !J);
            const Y = o.target.value, I = to(Y, So, /* @__PURE__ */ new Date());
            eo(I) && P(I), setTimeout(() => m(), 0);
          }
        },
        [m]
      );
      return h(() => {
        p !== void 0 && n(p);
      }, [p]), h(() => {
        if (u) {
          const o = setTimeout(m, 0);
          return () => clearTimeout(o);
        }
      }, [u, m]), h(() => {
        r !== void 0 && r !== L && P(r);
      }, [r, L]), /* @__PURE__ */ t("div", { children: /* @__PURE__ */ Q(
        Lo,
        {
          dateAdapter: Fo,
          adapterLocale: Po[C],
          children: [
            /* @__PURE__ */ t(uo, {}),
            w && /* @__PURE__ */ t(
              ho,
              {
                htmlFor: e,
                required: l,
                error: k,
                isOptional: F,
                children: w
              }
            ),
            /* @__PURE__ */ t(
              Do,
              {
                label: j,
                value: r,
                disabled: z,
                format: v,
                slots: {
                  openPickerIcon: Z,
                  textField: wo,
                  day: po,
                  leftArrowIcon: so,
                  rightArrowIcon: ro,
                  switchViewIcon: no,
                  ...K
                },
                slotProps: {
                  textField: {
                    inputProps: {
                      "data-testid": $
                    },
                    name: e,
                    fullWidth: _,
                    size: V,
                    helperText: R,
                    error: k,
                    required: l,
                    onClick: () => {
                      n(!0);
                    },
                    onKeyDown: N,
                    inputRef: O,
                    placeholder: B
                  },
                  desktopPaper: {
                    sx: {
                      borderRadius: 2
                    }
                  },
                  mobilePaper: {
                    sx: {
                      borderRadius: 2
                    }
                  },
                  openPickerButton: {
                    sx: {
                      padding: c === "small" ? 0.25 : 0.5,
                      marginRight: c === "small" ? -1.5 : -1.75
                    }
                  },
                  ...x
                },
                onChange: g,
                onAccept: H,
                inputRef: M,
                defaultValue: b,
                open: u,
                onClose: G,
                ...y
              }
            )
          ]
        }
      ) });
    }
  )
);
export {
  Xo as DatePickerBase
};
//# sourceMappingURL=index18.mjs.map
